import { render } from "./descriptions.vue?vue&type=template&id=5239a6c6&scoped=true&ts=true"
import script from "./descriptions.vue?vue&type=script&lang=ts"
export * from "./descriptions.vue?vue&type=script&lang=ts"

import "./descriptions.vue?vue&type=style&index=0&id=5239a6c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5239a6c6"]])

export default __exports__